module.exports = __webpack_public_path__ + "fonts/Decimal-Semibold.3cb9565.woff";